import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

/* =========================================================
 * ユーザー新規作成 (User Create)
 * ========================================================= */
export const fetchUserCreateRequest = () => ({
    type: ActionTypes.FETCH_USER_CREATE_REQUEST,
});

export const fetchUserCreateSuccess = (response) => ({
    type: ActionTypes.FETCH_USER_CREATE_SUCCESS,
    payload: response,
});

export const fetchUserCreateFailure = (error) => ({
    type: ActionTypes.FETCH_USER_CREATE_FAILURE,
    payload: error,
    error: true,
});

export const createUser = (formData) => async (dispatch) => {
  dispatch(fetchUserCreateRequest());

    try {
        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
            window.location.href = "/login";
            return;
        }

        const body = {
            login_id: formData.login_id,
            user_name: formData.user_name,
            authority_class: 0,
        };

        const response = await axiosInstance.post(`${BASE_URL}?path=user&type=insert-info-data`, body, {
                headers: {
                Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        const data = response.data;
        // APIが文字列のみを返す場合
        if (typeof data === "string") {
            dispatch(fetchUserCreateFailure(data));
            return { error: data };
        }

        if (!data || data.status !== 200) {
            const errorMsg =
                data?.message ||
                data?.respons?.message ||
                data?.respons ||
                "作成に失敗しました。";

            dispatch(fetchUserCreateFailure(errorMsg));
            return { error: errorMsg };
        }

        // 成功処理
        dispatch(fetchUserCreateSuccess(data.respons));
        return { payload: data.respons };

    } catch (err) {
        // Axiosでの例外エラー
        const errorMsg =
            err.response?.data ||
            err.response?.data?.respons ||
            err.response?.data?.message ||
            err.message;

        dispatch(fetchUserCreateFailure(errorMsg));
        return { error: errorMsg };
    }
};
